import React from 'react';
import { Path, Rect, SVG } from 'web-common/src/shared/design-system/Utilities';

interface GiftProps extends React.SVGProps<SVGSVGElement> {
  outline?: boolean;
}

export const Gift: React.FC<GiftProps> = ({ outline = false, ...props }) => {
  if (outline) {
    return <GiftOutline {...props} />;
  }

  return (
    <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
      <Path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M17.82 6H20C21.11 6 22 6.89 22 8H15H14H12H10H9H2.01C2.01 6.89 2.89 6 4 6H6.18C6.07 5.69 6 5.35 6 5C6 3.34 7.34 2 9 2C10.05 2 10.96 2.54 11.5 3.34L12 4.02L12.5 3.35C13.04 2.54 13.95 2 15 2C16.66 2 18 3.34 18 5C18 5.35 17.93 5.69 17.82 6ZM7.4 10H2.00818L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V10H16.6L19 13H16L14 10.5V19H10V10.5L8 13H5L7.4 10ZM14.293 4.29289C14.6819 3.90398 15.3183 3.90398 15.7072 4.29289C16.0961 4.68179 16.0961 5.31819 15.7072 5.7071C15.3183 6.09601 14 6 14 6C14 6 13.9041 4.68179 14.293 4.29289ZM10 6C10 6 10.096 4.6818 9.70711 4.29289C9.3182 3.90398 8.6818 3.90398 8.29289 4.29289C7.90398 4.6818 7.90398 5.3182 8.29289 5.70711C8.6818 6.09601 10 6 10 6Z'
      />
    </SVG>
  );
};

export const GiftOutline: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width='24' height='24' viewBox='0 0 24 24' {...props}>
    <Path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M17.82 6H20C21.11 6 22 6.89 22 8V19C22 20.11 21.11 21 20 21H4C2.89 21 2 20.11 2 19L2.01 8C2.01 6.89 2.89 6 4 6H6.18C6.07 5.69 6 5.35 6 5C6 3.34 7.34 2 9 2C10.05 2 10.96 2.54 11.5 3.34L12 4.02L12.5 3.35C13.04 2.54 13.95 2 15 2C16.66 2 18 3.34 18 5C18 5.35 17.93 5.69 17.82 6ZM15.7071 4.29289C15.3182 3.90398 14.6818 3.90398 14.2929 4.29289C13.904 4.6818 13.9999 6.00001 13.9999 6.00001C13.9999 6.00001 15.3182 6.09602 15.7071 5.70711C16.096 5.3182 16.096 4.6818 15.7071 4.29289ZM9.707 4.29289C10.0959 4.6818 9.99989 6 9.99989 6C9.99989 6 8.68169 6.09601 8.29278 5.7071C7.90387 5.3182 7.90387 4.6818 8.29278 4.29289C8.68169 3.90398 9.31809 3.90398 9.707 4.29289ZM4 8V19H20V8H14.92H9.08H4Z'
    />
    <Path d='M12 8H15L19 13H16L12 8Z' />
    <Path d='M12 8H9L5 13H8L12 8Z' />
    <Path d='M10 7H14V19H10V7Z' />
    <Rect x='4' y='8' width='16' height='2' />
  </SVG>
);
